import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/containers/auth/Login.vue';
import Signup from '@/containers/auth/Signup.vue';

import ShowResearch from '@/containers/research/ShowResearch.vue';
import CreateResearch from '@/containers/research/CreateResearch.vue';
import ListResearches from '@/containers/research/ListResearches.vue';

Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  const authUser = Vue.ls.get('token');
  if (to.meta.requiresAuth) {
    if (authUser) {
      next();
    } else {
      next({ name: 'Login' });
    }
  }
  next();
};

const ifNotAuthenticated = (to, from, next) => {
  const authUser = Vue.ls.get('token');
  if (!authUser) {
    next();
    return;
  }
  next('/');
};

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'ListResearches',
      component: ListResearches,
      beforeEnter: ifAuthenticated,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/research/brief',
      name: 'CreateResearch',
      component: CreateResearch,
      beforeEnter: ifAuthenticated,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/research/:id/brief',
      name: 'UpdateResearch',
      component: CreateResearch,
      beforeEnter: ifAuthenticated,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/research/:id/clusters',
      name: 'ShowResearch',
      component: ShowResearch,
      beforeEnter: ifAuthenticated,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: ifNotAuthenticated,
    },
  ],
});
